import React from 'react';

export default function PresentationPlayIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-presentation-play"><g><path className="primary" d="M11 18.62l-6.55 3.27a1 1 0 0 1-.9-1.78L11 16.38V5a1 1 0 0 1 2 0v11.38l7.45 3.73a1 1 0 0 1-.9 1.78L13 18.62V21a1 1 0 0 1-2 0v-2.38z"/><path className="secondary" d="M21 14a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2V4a1 1 0 1 1 0-2h18a1 1 0 0 1 0 2v10z"/><path className="primary" d="M15.51 8.14a1 1 0 0 1 0 1.72l-5 3A1 1 0 0 1 9 12V6a1 1 0 0 1 1.51-.86l5 3z"/></g></svg>
    </Tag>
  )
};
